export const PROVIDER_FILTERS = {
  bill_name: {
    title: 'Name',
    placeholder: 'Search by name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  bill_npi: {
    title: 'NPI',
    placeholder: 'Search by NPI',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  }
};
